import typescript from "../../../../assets/img/programming/typescript.webp";
import devhints from "../../../../assets/img/programming/devhints.webp";
import github from "../../../../assets/img/programming/github.webp";
import devdocs from "../../../../assets/img/programming/devdocs.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";

export const DataDoc = [
  {
    title: "Typescript Handbook",
    path: "https://www.typescriptlang.org/docs/handbook/intro.html",
    icon: typescript,
    cName: "icon",
    description:
      "The TypeScript Handbook is intended to be a comprehensive document that explains TypeScript to everyday programmers. You can read the handbook by going from top to bottom in the left-hand navigation.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
  {
    title: "Devhints",
    path: "https://devhints.io/typescript",
    icon: devhints,
    cName: "icon",
    description: "This is a collection of cheatsheets. Thanks to Rico.",
  },
  {
    title: "Awesome TypeScript",
    path: "https://github.com/dzharii/awesome-typescript",
    icon: github,
    cName: "icon",
    description:
      "A collection of awesome TypeScript resources for client-side and server-side development. Write your awesome JavaScript in TypeScript.",
  },

  {
    title: "DevDocs",
    path: "https://devdocs.io/typescript/",
    icon: devdocs,
    cName: "icon",
    description:
      "DevDocs combines multiple API documentations in a fast, organized, and searchable interface. It can be used Offline.",
  },
  {
    title: "Typescript Deep Dive",
    path: "https://basarat.gitbook.io/typescript/",
    icon: github,
    cName: "icon",
    description:
      "The definitive guide to TypeScript and possibly the best TypeScript book. Free and Open Source.",
  },
];
